import { Typography } from '@mui/material';
import { Stack } from '@mui/system';

import {
  DialogButtons,
  DialogContent,
  DialogMessageBox,
  DialogTitle,
} from '@verantos-dev/shared-components';

import { useRevertCohortDefinitionModal } from './useRevertCohortDefinitionModal';
import { useRevertCohortDefinitionModalString } from './useRevertCohortDefinitionModalString';
import { AutoSubmitDialogWrapper } from '../AutoSubmitDialogWrapper/AutoSubmitDialogWrapper';

export const RevertCohortDefinitionModal = () => {
  const { onClose, onSubmit, countDown, submittingError, isSubmitSuccess } =
    useRevertCohortDefinitionModal();

  const { messages } = useRevertCohortDefinitionModalString();

  if (submittingError) {
    return (
      <AutoSubmitDialogWrapper id="revert-cohort-definition-modal" onClose={onClose}>
        <DialogTitle id="cohort-builder-revert-modal-title" showClose={true} onClose={onClose}>
          {messages.title}
        </DialogTitle>
        <DialogContent>
          <DialogMessageBox
            id="cohort-builder-revert-modal-error"
            title={messages.errorTitle}
            type="error"
            text={`${messages.errorMessage} ${submittingError?.message || ''}`}
          />
        </DialogContent>
        <DialogButtons
          id="cohort-builder-revert-modal-confirmation-buttons"
          saveButton={{
            label: messages.retryBtn,
            onClick: onSubmit,
          }}
        />
      </AutoSubmitDialogWrapper>
    );
  }

  if (isSubmitSuccess) {
    return (
      <AutoSubmitDialogWrapper id="revert-cohort-definition-modal" onClose={onClose}>
        <DialogTitle id="cohort-builder-revert-modal-title" showClose={true} onClose={onClose}>
          {messages.title}
        </DialogTitle>
        <DialogContent>
          <Stack gap={4}>
            <DialogMessageBox
              id="cohort-builder-revert-modal-success"
              title={messages.successTitle}
              type="success"
              text={messages.successText}
            />
            <Typography variant="body2" style={{ fontSize: '12px' }}>
              Closing in {countDown}s
            </Typography>
          </Stack>
        </DialogContent>
      </AutoSubmitDialogWrapper>
    );
  }

  return (
    <AutoSubmitDialogWrapper
      id="revert-cohort-definition-modal"
      onClose={() => {
        // do nothing
      }}
    >
      <DialogTitle id="cohort-builder-revert-modal-title" showClose={false}>
        {messages.title}
      </DialogTitle>
      <DialogContent>
        <DialogMessageBox
          id="cohort-builder-revert-modal-loading"
          title={messages.loadingTitle}
          type="loading"
          text={messages.loadingText}
        />
      </DialogContent>
    </AutoSubmitDialogWrapper>
  );
};
